
import { Link } from 'react-router-dom';

const locations = [
  {
    name: 'İstanbul Avrupa',
    slug: 'istanbul-avrupa',
    image: 'https://public.readdy.ai/ai/img_res/57278a5ec25a2fab7d15cc440e9ba104.jpg'
  },
  {
    name: 'İstanbul Anadolu',
    slug: 'istanbul-anadolu',
    image: 'https://readdy.ai/api/search-image?query=Istanbul%20Asian%20side%20Anatolian%20coast%20modern%20buildings%20business%20centers%20industrial%20zones%20aerial%20view%20professional%20photography&width=600&height=400&seq=istanbul-anadolu-loc&orientation=landscape'
  },
  {
    name: 'Kocaeli',
    slug: 'kocaeli',
    image: 'https://readdy.ai/api/search-image?query=Kocaeli%20city%20industrial%20zone%20factories%20manufacturing%20plants%20port%20area%20aerial%20view%20professional%20photography%20Turkey&width=600&height=400&seq=kocaeli-loc&orientation=landscape'
  },
  {
    name: 'Gebze',
    slug: 'gebze',
    image: 'https://readdy.ai/api/search-image?query=Gebze%20organized%20industrial%20zone%20OSB%20factories%20manufacturing%20facilities%20logistics%20centers%20aerial%20view%20professional%20photography&width=600&height=400&seq=gebze-loc&orientation=landscape'
  },
  {
    name: 'Tuzla',
    slug: 'tuzla',
    image: 'https://readdy.ai/api/search-image?query=Tuzla%20shipyard%20industrial%20area%20manufacturing%20zone%20business%20district%20Istanbul%20aerial%20view%20professional%20photography&width=600&height=400&seq=tuzla-loc&orientation=landscape'
  },
  {
    name: 'Dilovası',
    slug: 'dilovasi',
    image: 'https://readdy.ai/api/search-image?query=Dilovasi%20organized%20industrial%20zone%20chemical%20plants%20factories%20manufacturing%20facilities%20Kocaeli%20aerial%20view%20professional%20photography&width=600&height=400&seq=dilovasi-loc&orientation=landscape'
  },
  {
    name: 'Çayırova',
    slug: 'cayirova',
    image: 'https://readdy.ai/api/search-image?query=Cayirova%20industrial%20district%20manufacturing%20zone%20business%20centers%20Kocaeli%20Turkey%20aerial%20view%20professional%20photography&width=600&height=400&seq=cayirova-loc&orientation=landscape'
  },
  {
    name: 'Bursa',
    slug: 'bursa',
    image: 'https://readdy.ai/api/search-image?query=Bursa%20city%20industrial%20zone%20automotive%20factories%20manufacturing%20plants%20Uludag%20mountain%20view%20aerial%20professional%20photography%20Turkey&width=600&height=400&seq=bursa-loc&orientation=landscape'
  },
  {
    name: 'Sakarya',
    slug: 'sakarya',
    image: 'https://readdy.ai/api/search-image?query=Sakarya%20city%20industrial%20zone%20manufacturing%20facilities%20business%20district%20Turkey%20aerial%20view%20professional%20photography&width=600&height=400&seq=sakarya-loc&orientation=landscape'
  },
  {
    name: 'Yalova',
    slug: 'yalova',
    image: 'https://readdy.ai/api/search-image?query=Yalova%20city%20coastal%20view%20industrial%20area%20business%20district%20Marmara%20sea%20Turkey%20aerial%20professional%20photography&width=600&height=400&seq=yalova-loc&orientation=landscape'
  },
  {
    name: 'Tekirdağ',
    slug: 'tekirdag',
    image: 'https://readdy.ai/api/search-image?query=Tekirdag%20city%20industrial%20zone%20port%20area%20manufacturing%20facilities%20Marmara%20region%20Turkey%20aerial%20view%20professional%20photography&width=600&height=400&seq=tekirdag-loc&orientation=landscape'
  },
  {
    name: 'Çorlu',
    slug: 'corlu',
    image: 'https://readdy.ai/api/search-image?query=Corlu%20organized%20industrial%20zone%20OSB%20textile%20factories%20manufacturing%20plants%20Tekirdag%20aerial%20view%20professional%20photography&width=600&height=400&seq=corlu-loc&orientation=landscape'
  },
  {
    name: 'Ataşehir',
    slug: 'atasehir',
    image: 'https://readdy.ai/api/search-image?query=Atasehir%20modern%20business%20district%20skyscrapers%20office%20towers%20financial%20center%20Istanbul%20aerial%20view%20professional%20photography&width=600&height=400&seq=atasehir-loc&orientation=landscape'
  },
  {
    name: 'Kadıköy',
    slug: 'kadikoy',
    image: 'https://readdy.ai/api/search-image?query=Kadikoy%20district%20Istanbul%20Asian%20side%20commercial%20area%20business%20centers%20waterfront%20Moda%20coast%20aerial%20view%20professional%20photography&width=600&height=400&seq=kadikoy-loc&orientation=landscape'
  },
  {
    name: 'Ümraniye',
    slug: 'umraniye',
    image: 'https://readdy.ai/api/search-image?query=Umraniye%20business%20district%20modern%20buildings%20commercial%20centers%20Istanbul%20Anatolian%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=umraniye-loc&orientation=landscape'
  },
  {
    name: 'Esenyurt',
    slug: 'esenyurt',
    image: 'https://readdy.ai/api/search-image?query=Esenyurt%20district%20modern%20residential%20commercial%20area%20Istanbul%20European%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=esenyurt-loc&orientation=landscape'
  },
  {
    name: 'Başakşehir',
    slug: 'basaksehir',
    image: 'https://readdy.ai/api/search-image?query=Basaksehir%20modern%20district%20residential%20commercial%20area%20Istanbul%20European%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=basaksehir-loc&orientation=landscape'
  },
  {
    name: 'Pendik',
    slug: 'pendik',
    image: 'https://readdy.ai/api/search-image?query=Pendik%20district%20industrial%20zone%20port%20area%20business%20centers%20Istanbul%20Asian%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=pendik-loc&orientation=landscape'
  },
  {
    name: 'Kartal',
    slug: 'kartal',
    image: 'https://readdy.ai/api/search-image?query=Kartal%20district%20business%20centers%20modern%20buildings%20commercial%20area%20Istanbul%20Asian%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=kartal-loc&orientation=landscape'
  },
  {
    name: 'Beylikdüzü',
    slug: 'beylikduzu',
    image: 'https://readdy.ai/api/search-image?query=Beylikduzu%20modern%20district%20residential%20commercial%20area%20Marmara%20coast%20Istanbul%20European%20side%20aerial%20view%20professional%20photography&width=600&height=400&seq=beylikduzu-loc&orientation=landscape'
  }
];

export default function LocationsSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-slate-900 to-slate-800 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzE0QjhBNiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
            <i className="ri-map-pin-line text-teal-400 text-lg"></i>
            <span className="text-teal-400 font-medium text-sm">Hizmet Bölgelerimiz</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Hizmet Verdiğimiz Bölgeler
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            İstanbul ve çevre illerde fiber optik ve güvenlik sistemleri hizmetleri sunuyoruz
          </p>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {locations.map((location, index) => (
            <Link
              key={location.slug}
              to={`/bolgeler/${location.slug}`}
              className="group relative h-64 rounded-xl overflow-hidden cursor-pointer"
              style={{
                animationDelay: `${index * 50}ms`
              }}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={location.image}
                  alt={`${location.name} Fiber Optik ve Güvenlik Sistemleri`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                {/* Badge */}
                <div className="mb-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-teal-500/90 text-white text-xs font-medium rounded-full">
                    <i className="ri-tools-line"></i>
                    Fiber & Güvenlik
                  </span>
                </div>

                {/* Location Name */}
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-teal-400 transition-colors">
                  {location.name}
                </h3>

                {/* Button */}
                <div className="flex items-center gap-2 text-teal-400 font-medium group-hover:gap-3 transition-all">
                  <span className="whitespace-nowrap">Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
              </div>

              {/* Hover Border Effect */}
              <div className="absolute inset-0 border-2 border-teal-500/0 group-hover:border-teal-500/50 rounded-xl transition-all duration-300"></div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-slate-300 text-lg mb-6">
            Bölgenizi göremiyor musunuz? Hemen bizimle iletişime geçin!
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="tel:+905537165561"
              className="inline-flex items-center gap-2 px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Hemen Ara</span>
            </a>
            <a
              href="https://wa.me/905537165561"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
